var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 17.4477 0.447715 17 1 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H1C0.447716 19 0 18.5523 0 18ZM10 3.828V14C10 14.5523 9.55229 15 9 15C8.44771 15 8 14.5523 8 14V3.828L2.63599 9.19289C2.24554 9.58341 1.61243 9.58343 1.22195 9.19295C0.831506 8.80251 0.831487 8.16948 1.22191 7.77901L8.29289 0.70719C8.68341 0.316627 9.31661 0.316608 9.70715 0.707148L16.7779 7.77794C17.1684 8.16844 17.1684 8.80156 16.7779 9.19206C16.3875 9.58251 15.7545 9.58256 15.3639 9.19217L10.0014 3.83141C10.0005 3.83051 10 3.82928 10 3.828Z",
    fill: "#F4F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadWhite);
export default __webpack_public_path__ + "static/media/icon-upload-white.2f43022e5ed94f4bba5ce58ed682ce16.svg";
export { ForwardRef as ReactComponent };